import React from "react";
import { Row, Form, Checkbox, Tooltip } from "antd";
import { RadioButtonWrapper, DisplayFlexAlign, MainWrapper, MailContentWrapper, SpanWrap, MailContentWrapperfirst, RadioWrappered } from "../../../Components/Step1Setup/styles";
import infoIcon from "../../../../../assets/icons/shape.svg";
import { SecondColumn, DetailsContainer, DetailsData } from "../../../styles";
import { AccessCol } from "./styles";
import { InvitePartiesAccessLevel, Underlinelinks, AccessDescription, Title, CheckboxWrappered, Namecheckbox, Description } from  "../../../Components/InviteInterestedParties/Components/styles";
import AccessModal from "../../../../MyAccounts/Components/PopUp/AccessModal";
import { ContentProvider, ContentMessage, Types } from "../../../../../CommonComponents/ContentMessages";
import PropTypes from "prop-types";
import { RadioButton, CustomCheckbox } from "../../../../../CommonComponents/commonStyles";

class AccessLevel extends React.Component {
  state = {
    modalVisible: false,
    showType: ''
  };

  setModalVisible(modalVisible) {
    this.setState({ modalVisible, showType: 'hyperlink'});
  }

  render() {    

    const { formFields, setData } = this.props;

    return (
      <React.Fragment>
        <div data-test="accessLevelBlock">
        <Row>
          <MainWrapper>
          <ContentProvider types={[Types.GET_MODAL_CONTENT]} pages={['Access Modal']} >
              {this.state.modalVisible && this.state.showType === "hyperlink" ? (
                <AccessModal
                  data-test="modal-visible"
                  setModalVisible={(value) => this.setModalVisible(value)}
                  modalVisible = {this.state.modalVisible}
                />
              ) : null}
            </ContentProvider>
            <AccessCol lg={5} sm={24} xs={24}>
              <RadioWrappered>
                <Form.Item label={<Title>Access Level</Title>}>
                  <RadioButtonWrapper
                    data-test="access-level"
                    id="radioBtnAccessLevel"
                    defaultValue={1}
                    onChange={e => setData(e.target.value, "accessLevel")}
                    value={formFields.accessLevel.value}
                  >
                    <InvitePartiesAccessLevel>
                      <MailContentWrapper>
                        <DisplayFlexAlign>
                          <RadioButton value="Full access">
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Invite interested parties" property="field_type_5_title" defaultMessage="Full Access" />
                          </RadioButton>
                        </DisplayFlexAlign>
                      </MailContentWrapper>
                      <MailContentWrapperfirst>
                        <RadioButton value="Read Only + Exchange">
                          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Invite interested parties" property="field_type_5_1_title" defaultMessage="Read Only + Exchange" />
                        </RadioButton>
                      </MailContentWrapperfirst>
                      <MailContentWrapperfirst>
                        <RadioButton value="Read Only">
                          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Invite interested parties" property="field_type_6_title" defaultMessage="Read Only" />
                        </RadioButton>
                      </MailContentWrapperfirst>
                      <MailContentWrapperfirst>
                        <RadioButton value="No Access">
                          <SpanWrap>                            
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Invite interested parties" property="field_type_7_title" defaultMessage="Paper-statement access" />
                          </SpanWrap>
                        </RadioButton>
                      </MailContentWrapperfirst>
                    </InvitePartiesAccessLevel>
                  </RadioButtonWrapper>
                </Form.Item>
              </RadioWrappered>
            </AccessCol>
            <div className="linedisplay" />
            <SecondColumn lg={15} sm={24} xs={24}>
              <DetailsContainer>
                <DetailsData>
                  {formFields.accessLevel.value === "Full access" && (
                    <AccessDescription>
                      <Description>                        
                        <ContentMessage messageId="fullAccessInfo" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="Invite interested parties" property="field_type_5_description" defaultMessage={'<p>In addition to other permissions, this person can receive statements, view account activity, recommend grants and exchanges, and view/receive confirmations for contributions, grants, exchanges and other account activity. They can link their personal Vanguard account to the Vanguard Charitable account. For more information, see our <a href="/company-policies/policies-and-guidelines" target="_blank">Policies and Guidelines</a>.</p>'} />
                      </Description>
                    </AccessDescription>
                  )}
                  {formFields.accessLevel.value === "Read Only + Exchange" && (
                    <AccessDescription>
                      <Description>                        
                        <ContentMessage messageId="readOnlyWithExchange" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="Invite interested parties" property="field_type_5_1_description" defaultMessage={'<p>This person can receive statements, view account activity, and make investment exchanges. For more information see our  <a href="/company-policies/policies-and-guidelines" target="_blank">Policies & Guidelines</a></p>'} />
                      </Description>
                    </AccessDescription>
                  )}
                  {formFields.accessLevel.value === "Read Only" && (
                    <AccessDescription>
                      <Description>                        
                        <ContentMessage messageId="readOnly" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="Invite interested parties" property="field_type_6_description" defaultMessage={'<p>This person can receive statements, view account activity, and link their personal Vanguard account to the Vanguard Charitable account to facilitate donations.</p>'} />
                      </Description>
                    </AccessDescription>
                  )}
                  {formFields.accessLevel.value ===
                    "No Access" && (
                    <AccessDescription>
                      <Description>
                      <ContentMessage messageId="paperStatement" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="Invite interested parties" property="field_type_7_description" defaultMessage={'<p>This person can receive paper statements, but has no advisory privileges or online access to the account.</p>'} />                        
                      </Description>
                    </AccessDescription>
                  )}
                </DetailsData>
              </DetailsContainer>             
              <MailContentWrapperfirst>
                <Underlinelinks id="anrAccessLevel" onClick={() => this.setModalVisible(true)}>
                View access levels
                </Underlinelinks>
                </MailContentWrapperfirst>
              </SecondColumn>
            </MainWrapper>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

AccessLevel.propTypes = {
  formFields: PropTypes.objectOf(PropTypes.object),
  setData: PropTypes.func.isRequired
}


export default AccessLevel;